export type Variants = readonly [string, readonly string[]];

const resolveVariant = (value: string, defaultVariant: string, allVariants: readonly string[]) => {
  const variantArr = value.split(' ');
  const variantValid = variantArr.some(variant => allVariants.includes(variant));
  if (variantValid) {
    return value;
  } else {
    console.warn(`Variant "${value}" not found, setting default (${defaultVariant}) instead`);
    return defaultVariant;
  }
};

/**
 * @deprecated use multiple input as component props
 */
export const ComponentVariant = function ([defaultVariant, allVariants]: Variants) {
  return function <T extends { variant: string }, K extends 'variant'>(target: T, propertyKey: K) {
    const valueKey = '__variant__';
    Object.defineProperty(target, propertyKey, {
      set: function (this: any, value: string) {
        this[valueKey] = resolveVariant(value, defaultVariant, allVariants);
      },
      get: function (this: any) {
        return this[valueKey] || defaultVariant;
      },
    });
  };
};

/**
 * @deprecated same as above created for input migration, don't use it in new components
 */
export const ComponentVariantTransform = ([defaultVariant, allVariants]: Variants) =>
  <const>[
    defaultVariant,
    {
      transform: (value: string) => resolveVariant(value, defaultVariant, allVariants),
    },
  ];
